import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { StormBanner } from './components/StormBanner';
import { Services } from './components/Services';
import { WhyUs } from './components/WhyUs';
import { BeforeAfter } from './components/BeforeAfter';
import { Testimonials } from './components/Testimonials';
import { StormPrepCTA } from './components/StormPrepCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-brand-bg font-body" data-id="element-0">
      <Navbar data-id="element-1" />
      <Hero data-id="element-2" />
      <StormBanner data-id="element-3" />
      <Services data-id="element-4" />
      <WhyUs data-id="element-5" />
      <BeforeAfter data-id="element-6" />
      <Testimonials data-id="element-7" />
      <StormPrepCTA data-id="element-8" />
      <Footer data-id="element-9" />
    </div>;
}